import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

import app from "./modules/app"
import user from "./modules/user"

export default new Vuex.Store({
    modules: {
        app,
        user
    }
});
